module.exports = __webpack_public_path__ + "img/4.9750c8f8.png";